import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsComponent } from './contacts/contacts.component';
import { RouteCanActivateGuard } from './services/route-can-activate-guard.service';
import { UnauthorizedErrorComponent } from './errorsPage/unauthorizedError/unauthorized-error.component';
import { NotFoundErrorComponent } from './errorsPage/notFoundError/not-found-error.component';

export const routes: Routes = [
  { path: 'error/notfound', component: NotFoundErrorComponent },
  { path: 'error/unauthorized', component: UnauthorizedErrorComponent },
  {
    path: '**',
    component: ContactsComponent,
    canActivate: [RouteCanActivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
